import { useScreenClass } from 'react-grid-system';

export const useIsMobile = () => {
  const screen = useScreenClass();
  return screen === 'sm' || screen === 'xs';
};
